import { useState } from "react";
import { Ticket } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PromoRedeem({ onDone }) {
  const { user, setUser } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user || user.promo_access) return null;

  const redeem = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/promo/redeem", { code });
      setUser(data);
      toast.success("Promo code applied — you have free access!");
      onDone?.();
    } catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={redeem} data-testid="promo-form" className="flex flex-wrap items-center gap-2 rounded-2xl border border-dashed border-[#00E5A3]/50 bg-[#00E5A3]/5 p-3">
      <Ticket className="h-4 w-4 text-[#00E5A3]" />
      <span className="text-sm text-slate-300">Have a promo code?</span>
      <input data-testid="promo-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="ENTER CODE"
        className="flex-1 min-w-[140px] bg-[#0B0F19] border border-[#26334D] rounded-full px-4 py-2 text-sm font-mono-vv tracking-wider outline-none focus:border-[#00E5A3]" />
      <Button data-testid="promo-redeem-button" type="submit" disabled={busy || !code.trim()}
        className="rounded-full bg-[#00E5A3] hover:bg-[#00C98F] text-[#0B0F19] font-semibold">{busy ? "Checking…" : "Apply"}</Button>
    </form>
  );
}
